import {
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CART_INTERMEDIATE,
} from 'shared/consts'
import {
  CROSSSELL_LAYOUT,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import store from 'shared/store'
import buildClientAPI from 'views/providers/clientAPI'
import createA11Dialog from 'views/utils/createA11Dialog'

const showCrosssellModal = async () => {
  const { cartServiceV3 } = buildClientAPI()
  const miniCart = await cartServiceV3.fetchMiniCart()

  const cartQuantity = miniCart?.data?.entriesInCart || 0

  const modalContainer = <HTMLElement>document.getElementById(CROSSSELL_LAYOUT)
  const crosssellLayoutShown = sessionStorage.getItem('crosssellLayoutShown')

  if (modalContainer && cartQuantity === 0 && !crosssellLayoutShown) {
    const modal = createA11Dialog({
      element: modalContainer,
    })

    const crosssellLayoutTimeout = setTimeout(() => {
      modal.show()
      sessionStorage.setItem('crosssellLayoutShown', '1')
      clearTimeout(crosssellLayoutTimeout)
    }, 150000)

    document
      .querySelector('.o-CrosssellLayout__go-back')
      ?.addEventListener('click', () => modal.hide())
  }
}

export default async () => {
  const crosssellLayout = getExperimentOnClient(CROSSSELL_LAYOUT)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType = '' } = publicRuntimeConfig?.pageProperties || {}

  if (
    crosssellLayout.isEnabled &&
    ![PAGE_TYPE_ACCOUNT, PAGE_TYPE_CART, PAGE_TYPE_CART_INTERMEDIATE].includes(
      pageType
    )
  ) {
    if (crosssellLayout.variant !== EXPERIMENT_VARIATION.DEFAULT) {
      await showCrosssellModal()
    }

    trackCswSlider({})
  }
}
